<div fxLayout="column" fxLayoutGap="20px">
    <div *ngIf="year" fxFlex="row" fxLayoutAlign="center center" fxLayoutGap="4px">
        <span class="txt-p-16-4">{{ 'Make your choice for the year'|i18n }} </span>
        <span class="txt-p-16-7">{{ year }}.</span>
    </div>
    <div class="bill-dialog" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="30px" [formGroup]="form">
        <div class="w-60" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
            <div fxFlex="60" fxLayout="row" fxLayoutAlign="end center">
                <span>{{ 'Withdrawal provided for this facility'|i18n }}:*</span>
            </div>
            <div fxFlex="30" app-input-container>
                <input app-input
                       type="number"
                       formControlName="plantRei"
                       step="0.01"
                       (input)="limitDecimals(form, 'plantRei')">
                <div *ngIf="!form.controls.plantRei.pristine && form.controls.plantRei.invalid" app-error>
                    {{ 'Invalid value'|i18n }}
                </div>
            </div>
            <div fxFlex="10" fxLayout="row" fxLayoutAlign="start center">
                <span>€</span>
            </div>
        </div>
        <div class="w-60" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
            <div fxFlex="60" fxLayout="row" fxLayoutAlign="end center">
                <span>{{ 'Injected energy'|i18n }}:</span>
            </div>
            <div fxFlex="30" app-input-container>
                <input app-input
                       type="number"
                       formControlName="plantInjected"
                       step="0.01"
                       (input)="limitDecimals(form, 'plantInjected')">
                <div *ngIf="!form.controls.plantInjected.pristine && form.controls.plantInjected.invalid" app-error>
                    {{ 'Invalid value'|i18n }}
                </div>
            </div>
            <div fxFlex="10" fxLayout="row" fxLayoutAlign="start center">
                <span>kWh</span>
            </div>
        </div>
    </div>
</div>
